import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { round } from "../utils";
import { isElanFsUser } from "../utils/auth";

//prettier-ignore
const dataKey = ["count_00", "count_01", "count_02", "count_03", "count_04", "count_05", "count_06", "count_07", "count_08", "count_09", "count_10", "count_11", "count_12", "count_13", "count_14", "count_15", "count_16", "count_17", "count_18", "count_19", "count_20", "count_21", "count_22", "count_23"];

const parseNumber = (number) => {
  return !isNaN(number) ? parseInt(number) : 0;
}

const getMetric = (data) => {
  const transactionSum =
    parseNumber(data.find((row) => row.status_name === "transaction")?.count_sum) ?? 0;
  const errorSum =
    parseNumber(data.find((row) => row.status_name === "error")?.count_sum) ?? 0;

  return (transactionSum + errorSum) === 0
    ? 0
    : round((1 - (errorSum / (errorSum + transactionSum))) * 100, 2);
};

const verifyAndModifyData = (data, transactionLabel) => {
  if (data.length === 2 && data[0].status_name) {
    return data.sort((a, b) => a.status_id - b.status_id);
  } else if (data[0]?.status_name === "error") {
    return [
      {
        status_name: "transaction",
        count_sum: 0,
        status_label: transactionLabel,
      },
      ...data,
    ];
  } else if (data[0]?.status_name === "transaction") {
    return [
      ...data,
      { status_name: "error", count_sum: 0, status_label: "Errors" },
    ];
  } else if (!data[0]?.status_name && !data[1]?.status_name) {
    return [
      {
        status_name: "transaction",
        count_sum: 0,
        status_label: transactionLabel,
      },
      { status_name: "error", count_sum: 0, status_label: "Errors" },
    ];
  } else return data;
};

const hasActivity = (data) => {
  const transactionSum = parseNumber(data.find((row) => row.status_name === "transaction")?.count_sum) ?? 0;
  const errorSum = parseNumber(data.find((row) => row.status_name === "error")?.count_sum) ?? 0;
  return (transactionSum + errorSum) > 0;
};

const HourlyView = ({ data: pData, title = "", transactionLabel = "Transactions" }) => {
  const [isMounted, setIsMounted] = useState(false);
  const data = verifyAndModifyData(pData, transactionLabel);

  const selectedService = sessionStorage.getItem("location");

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (isMounted && selectedService === title) {
    const el = document.getElementById(title);
    el.scrollIntoView({
      behavior: "auto",
      block: "center",
    });
  }

  return (
    <Paper variant="outlined" id={title}>
      <Paper
        sx={{
          px: 2,
          py: 1,
          bgcolor: isElanFsUser() ? "secondary.main" : "primary.main",
          color: "common.white",
        }}
      >
        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1">{title}</Typography>
          <Chip
            label={hasActivity(data) ? `Overall Success: ${getMetric(data)} %` : 'No Activity'}
            size="small"
            sx={{
              bgcolor: "common.white",
              color: hasActivity(data)
                ? (getMetric(data) >= 99.99 ? "success.main" : "error.main")
                : "error.main",
            }}
          />
        </Stack>
      </Paper>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 0,
          borderTop: 1,
          borderColor: "grey.300",
          borderRadius: 0,
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>Hour</TableCell>
              {Array.from({ length: 24 }, (_, index) => (
                <TableCell key={index}>{index}</TableCell>
              ))}
            </TableRow>

            <TableRow key={data[0].status_label}>
              <TableCell>
                <div>{transactionLabel.split("(")[0].trim()}</div>
                {transactionLabel.includes("(") && (
                  <div style={{ fontSize: "8px", color: "#666" }}>
                    ({transactionLabel.split("(")[1].replace(")", "")})
                  </div>
                )}
              </TableCell>
              {dataKey.map((key) => (
                <TableCell key={key}>{(parseNumber(data[0]?.[key]) + parseNumber(data[1]?.[key])) ?? 0}</TableCell>
              ))}
            </TableRow>

            <TableRow key={data[1].status_label}>
              <TableCell>{data[1].status_label}</TableCell>
              {dataKey.map((key) => (
                <TableCell key={key}>{parseNumber(data[1]?.[key]) ?? 0}</TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default HourlyView;
